import Tooltip from './Tooltip';

export default Tooltip;
export type { TooltipProps } from './Tooltip';
